import PropTypes from 'prop-types';
import React from 'react';
import fetch from 'isomorphic-fetch';
import path from 'path';
import url from 'url';

import browserHistory from '../util/browserHistory';
import { url as utilUrl } from '../util/env';
import subdomain from '../util/subdomain';
import ENV from '../env';

export const isLoggedIn = (next, replace, done) => {
  loggedIn().then(isLoggedIn => {
    if (!isLoggedIn) {
      const embeddedMode = JSON.parse(ENV.PUSHBOT_EMBEDDED_MODE);
      const pathname = embeddedMode ? '/auth' : '/login';
      browserHistory.push(pathname);
      return done();
    }
    done();
  });
};

export const anonymous = isLoggedIn;

export const authenticate = isLoggedIn;

export const authenticateUser = isLoggedIn;

export const checkAuthMethod = (baseUrl, teamName, done) => {
  // Fetch rather than dispatching the request to the store as
  // dispatching here causes the page to not load in a testing environment
  fetch(`${baseUrl}/teams/${teamName}/authinfo`, {
    credentials: 'same-origin'
  }).then(
    response =>
      response.json().then(data => done(null, data.method), err => done(err)),
    err => done(err)
  );
};

// eslint-disable-next-line no-unused-vars
export const createUrlFormatter = userExp => {
  return (path = '/', search = '') => {
    const pathname = path.replace(/^\/alpha/, '').replace(/^\//, '');
    const urlObj = { search };
    return url.format({ ...urlObj, pathname });
  };
};

export const errorLoadingRoute = err => {
  console.error('Error loading a dynamic route', err);
};

export const loadRoute = cb => {
  return module => cb(null, module.default);
};

export const loggedIn = () => {
  const teamName = subdomain();
  const baseUrl = utilUrl(ENV);
  return fetch(`${baseUrl}/teams/${teamName}/users/me`, {
    credentials: 'same-origin'
  }).then(response => response.ok);
};

export function Noop({ children }) {
  return <div className="container-fluid">{children}</div>;
}

Noop.displayName = 'Noop';

Noop.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export const parseAuthenticationToken = ({
  query: { username, token } = {},
  hash: action // eslint-disable-line no-unused-vars
} = {}) => (username && token ? { username, token } : {});

export const redirectReferrer = (basepath = '/') => (next, replace) => {
  const { location = {} } = next;
  const { query: { referrer = '/' } = {} } = location;
  replace({
    pathname: path.join(basepath, referrer),
    state: { referrer: location }
  });
};

export const releasePath =
  ENV.PUSHBOT_WEB_PATH !== '/' ? ENV.PUSHBOT_WEB_PATH : undefined;

export const versionRedirect = ({ pathname, search, userExp }, replace) => {
  const createUrl = createUrlFormatter(userExp);

  const targetUrl = `${pathname}${search}`;
  const formattedUrl = createUrl(pathname, search);

  if (targetUrl !== formattedUrl) {
    replace(formattedUrl);
  }
};



// WEBPACK FOOTER //
// ./js/routes/util.js